// frontend-web/src/pages/Admin/StudyContentEdit.jsx
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function StudyContentEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const editorRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    content_text: "",
    is_premium: false
  });

  useEffect(() => {
    loadContent();
    setupPasteHandler();
  }, [id]);

  const loadContent = async () => {
    try {
      const res = await api.get(`/admin/study/content/single/${id}`);
      setFormData({
        title: res.data.title || "",
        content_text: res.data.content_text || "",
        is_premium: res.data.is_premium || false
      });
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.innerHTML = res.data.content_text || "";
        }
      }, 100);
    } catch (err) {
      alert("Failed to load content");
    } finally {
      setLoading(false);
    }
  };

  const setupPasteHandler = () => {
    document.addEventListener("paste", handlePaste);
  };

  const handlePaste = async (e) => {
    if (!editorRef.current?.contains(e.target)) return;

    const items = e.clipboardData.items;
    for (let item of items) {
      if (item.type.indexOf("image") !== -1) {
        e.preventDefault();
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = document.createElement("img");
          img.src = event.target.result;
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          img.style.borderRadius = "8px";
          img.style.margin = "10px 0";
          editorRef.current.appendChild(img);
          editorRef.current.appendChild(document.createElement("br"));
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleSave = async () => {
    setSaving(true);
    const updatedContent = editorRef.current.innerHTML;

    try {
      await api.put(`/admin/study/content/${id}`, {
        title: formData.title,
        content_text: updatedContent,
        is_premium: formData.is_premium
      });
      alert("Content updated successfully!");
      navigate(-1);
    } catch (err) {
      alert("Failed to update content");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{padding: "50px", textAlign: "center", fontSize: "18px"}}>Loading content...</div>;

  return (
    <div style={{padding: "30px", maxWidth: "1000px", margin: "0 auto", fontFamily: "Inter, system-ui, sans-serif"}}>
      <button 
        onClick={() => navigate(-1)} 
        style={{padding: "10px 20px", background: "#6b7280", color: "white", border: "none", borderRadius: "8px", marginBottom: "20px", cursor: "pointer"}}
      >
        Back
      </button>

      <h1 style={{fontSize: "28px", marginBottom: "30px", color: "#1e293b"}}>Edit Study Content</h1>

      <div style={{background: "white", padding: "30px", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)"}}>

        <div style={{marginBottom: "24px"}}>
          <label style={{display: "block", marginBottom: "8px", fontWeight: 600, fontSize: "16px"}}>Title</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            style={{width: "100%", padding: "14px", border: "2px solid #e2e8f0", borderRadius: "10px", fontSize: "16px"}}
            placeholder="Enter chapter title..."
            required
          />
        </div>

        <div style={{marginBottom: "24px"}}>
          <label style={{display: "block", marginBottom: "12px", fontWeight: 600, fontSize: "16px"}}>
            Content (Paste images with Ctrl+V)
          </label>
          <div 
            ref={editorRef}
            contentEditable={true}
            style={{
              minHeight: "500px",
              padding: "20px",
              border: "2px solid #3b82f6",
              borderRadius: "12px",
              background: "#f8faff",
              fontSize: "17px",
              lineHeight: "1.8",
              outline: "none",
              backgroundImage: "linear-gradient(transparent 28px, #e0e7ff 28px)",
              backgroundSize: "100% 29px"
            }}
            dangerouslySetInnerHTML={{ __html: formData.content_text }}
          />
          <small style={{color: "#6366f1", fontWeight: 600, marginTop: "8px", display: "block"}}>
            Tip: Image paste karne ke liye Ctrl+V dabao ya drag & drop karo
          </small>
        </div>

        <div style={{marginBottom: "30px", display: "flex", alignItems: "center", gap: "12px"}}>
          <input
            type="checkbox"
            id="premium"
            checked={formData.is_premium}
            onChange={(e) => setFormData({...formData, is_premium: e.target.checked})}
            style={{width: "20px", height: "20px", cursor: "pointer"}}
          />
          <label htmlFor="premium" style={{fontWeight: 600, fontSize: "16px", cursor: "pointer"}}>
            Premium Content (Only for paid users)
          </label>
        </div>

        <button 
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: "16px 40px",
            background: saving ? "#94a3b8" : "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "12px",
            fontSize: "18px",
            fontWeight: 600,
            cursor: saving ? "not-allowed" : "pointer",
            boxShadow: "0 8px 25px rgba(59,130,246,0.4)"
          }}
        >
          {saving ? "Saving..." : "Update Content"}
        </button>
      </div>
    </div>
  );
}